<template>
  <div class="p-4" id="faq-page">
    <!-- JUMBOTRON -->
    <search-faq-jumbotron @onSearchInput="onSearchInput"></search-faq-jumbotron>

    <!--FAQ FILTER BY UNIT-->
    <div class="vx-row">
      <div class="vx-col w-full sm:w-2/5 md:w-2/5 lg:w-1/4 rounded-lg">
        <filter-course-unit @onFilterUnitClick="onFilterUnitClick"
                            :faqFilter="faqFilter"
                            :courseOutlineUnits="courseOutlineUnits"
                            :currentFocusUnit="currentFocusUnit">
        </filter-course-unit>
      </div>

      <!-- FAQ COL -->
      <div class="vx-col w-full sm:w-3/5 md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
        <div id="div-with-loading"
             class="vs-con-loading__container w-full"
             :style="isLoading ? 'height: 200px;':''">
        </div>
        <faq-collapse v-if="!isLoading"
                      :filteredFaq="filteredFaq"
                      @updateHitRateCount="updateHitRateCount">
        </faq-collapse>
      </div>
    </div>
  </div>
</template>

<script>
  import SearchFaqJumbotron from "./SearchFaqJumbotron";
  import FilterCourseUnit from "./FilterCourseUnit";
  import FaqCollapse from "./FaqCollapse";
  import store from '@/store';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import CourseFaq from '@/store/modules/class-room/course-faq/index';

  if (!store.state.CourseFaq) store.state.registerModule(`CourseFaq`, CourseFaq);

  const {
    mapActions: mapCourseFaqActions,
  } = createNamespacedHelpers(`CourseFaq`);
  const {
    mapFields: mapCourseFaqFields,
  } = createHelpers({
    getterType: `CourseFaq/getField`,
    mutationType: `CourseFaq/updateField`,
  });

  export default {
    props: [
      'courseOutlineUnits',
      'currentFocusUnit',
      'classSection',
      'studentEnrollDetail',
    ],
    components: {
      SearchFaqJumbotron,
      FilterCourseUnit,
      FaqCollapse,
    },
    data() {
      return {
        faqSearchQuery: '',
        faqFilter: this.currentFocusUnit ? this.currentFocusUnit.id : '',
        isLoading: false,
      }
    },
    computed: {
      ...mapCourseFaqFields({
        courseFaqs: 'courseFaqs',
        courseFaqProcessing: 'processing',
        courseFaqError: 'error',
        courseFaqSuccess: 'success'
      }),
      filteredFaq() {
        if (this.courseFaqs && this.courseFaqs.length > 0) {
          return this.courseFaqs.filter((faq) => {
            return faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase())
              || faq.answer.toLowerCase().includes(this.faqSearchQuery.toLowerCase())
          })
        }
        return [];
      },
    },
    watch: {
      async currentFocusUnit(val) {
        this.setFaqFilter(val.id);
        await this.loadData();
      },
      isLoading(val) {
        if (val) {
          this.$vs.loading({
            container: '#div-with-loading',
            scale: 1
          })
        } else {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
        }
      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapCourseFaqActions({
        getCourseFaqsByFilter: 'getCourseFaqsByFilter',
        updateCourseFaqHitCount: 'updateCourseFaqHitCount',
      }),
      onSearchInput(search) {
        this.faqSearchQuery = search;
      },
      async onFilterUnitClick(unitId) {
        this.setFaqFilter(unitId);
        const payload = {
          courseFAQFilterInput: {
            courseOutlineId: this.studentEnrollDetail.courseOutlineRegistration.courseOutline.id,
            courseOutlineUnitId: unitId,
          }
        };
        await this.filterData(payload);
      },
      async updateHitRateCount(courseFaq) {
        const payload = {
          id: courseFaq.id
        };
        await this.updateCourseFaqHitCount(payload)
      },
      async loadData() {
        const payload = {
          courseFAQFilterInput: {
            courseOutlineId: this.studentEnrollDetail.courseOutlineRegistration.courseOutline.id,
            courseOutlineUnitId: this.currentFocusUnit ? this.currentFocusUnit.id : '',
          }
        };

        await this.filterData(payload)
      },
      async filterData(payload) {
        this.isLoading = true;
        await this.getCourseFaqsByFilter(payload)
        this.isLoading = false;
      },
      setFaqFilter(unitId) {
        this.faqFilter = unitId;
      }
    },
    async beforeMount() {
      await this.loadData();
    }
  }
</script>

<style lang="scss">
  #faq-page {
    .faq-jumbotron-content {
      background-image: url('../../../../../../assets/images/pages/faq.jpg');
      background-size: cover;
    }

    .faq-bg {
      background-color: #fff;
    }
  }

  .vs-popup--background {
    background: inherit !important;
  }

  .vs-popup--header {
    background: #805ad5;
  }

  .vs-popup--title h3 {
    color: #ffffff !important;
    padding: 15px;
    font-size: 1.2rem !important;
  }

  textarea.vs-textarea {
    height: 100px !important;
  }

  .con-input-search.vs-table--search {
    margin-left: 15px !important;
  }

  @media (max-width: 575px) {
    .con-input-search.vs-table--search {
      margin-top: auto;
      padding-bottom: 0 !important;
    }
    .header-table.vs-table--header {
      padding: 5px;
    }
  }

  // @media (min-width:412px) {
  //   .con-input-search.vs-table--search {
  //     padding-bottom:0 !important;
  //   }
  // }
</style>
